// IF UPDATED - Update the corresponding types in API Constants

export const validFileTypes = [
  { extension: '.pdf', mimeType: 'application/pdf' },
  { extension: '.jpg', mimeType: 'image/jpeg' },
  { extension: '.jpeg', mimeType: 'image/jpeg' },
  { extension: '.png', mimeType: 'image/png' },
];
